import type { BadgeProps } from 'antd';
import { Badge, Calendar, Select, Row, Col, Radio } from 'antd';
import type { Moment } from 'moment';
import React, { useState } from 'react';
import { Music } from "../store/types";
import ModalMusic from './ModalMusic';
import moment from 'moment';

type CalendarMode = 'year' | 'month';
/*type HeaderRender<T> = (
  value: T,
  type: string,
  onChange: (date: T) => void,
  onTypeChange: (type: string) => void,
) => React.ReactNode;*/
type CalendarBoxType = {
  musics: Music[];
  selectMusic?: Function;
  deleteMusic?: Function;
  year: number | null;
  selectYear: Function;
};
type CalendarHeaderProps = {
  value: Moment,
  type: string,
  onChange: (date: Moment) => void,
  onTypeChange: (type: CalendarMode) => void,
}

const styles = {
  events: {
	  margin: 0,
	  padding: 0,
	  listStyle: 'none',
  } as React.CSSProperties,
  antBadgeStatus: {
	  width: '100%',
	  overflow: 'hidden',
	  fontSize: '12px',
	  whiteSpace: 'nowrap',
	  textOverflow: 'ellipsis',
  },
	notesMonth: {
	  fontSize: '28px',
	  textAlign: 'center',
	},
	section: {
		fontSize: '28px',
	},
};

const getListData = (value: Moment, musics: Music[]) => {
	const date = value.format('YYYY-MM-DD');
	const listData = [];
	for (let i = 0; i < musics.length; i++) {
		const author = musics[i].author ? musics[i].author[0].toUpperCase() + musics[i].author.substr(1) + ' - ' : '';
		const title = musics[i].title[0].toUpperCase() + musics[i].title.substr(1);
		if (musics[i].date.slice(0, 10) === date)
			listData.push({
				musicId: i,
        type: 'success',
        content: author + title,
			})
	}
  return listData || [];
};

const getMonthData = (value: Moment, musics: Music[]) => {
	const month = value.format('YYYY-MM');
	const listData = [];
	for (let i = 0; i < musics.length; i++) {
		const author = musics[i].author ? musics[i].author[0].toUpperCase() + musics[i].author.substr(1) + ' - ' : '';
		const title = musics[i].title[0].toUpperCase() + musics[i].title.substr(1);
		if (musics[i].date.slice(0, 7) === month)
			listData.push({
				musicId: i,
        type: 'success',
        content: author + title,
			})
	}
  return listData || [];
};

const CalendarHeader = (props: CalendarHeaderProps) => {
  const { value, type, onChange, onTypeChange } = props;
  const start = 0;
  const end = 12;
  const monthOptions = [];
  const current = value.clone();
  const localeData = value.localeData();
  const months = [];
  for (let i = 0; i < 12; i++) {
    current.month(i);
    months.push(localeData.monthsShort(current));
  }
  for (let i = start; i < end; i++) {
    monthOptions.push(
      <Select.Option key={i} value={i} className="month-item">
        {months[i]}
      </Select.Option>,
    );
  }
  const month = value.month();
  return (
    <div style={{ padding: 8 }}>
      <Row gutter={8}>
        <Col>
          <Radio.Group
            size="small"
            onChange={e => onTypeChange(e.target.value)}
            value={type}
          >
            <Radio.Button value="year">Year</Radio.Button>
            <Radio.Button value="month">Month</Radio.Button>
          </Radio.Group>
        </Col>
        <Col>
          <Select
            size="small"
            dropdownMatchSelectWidth={false}
            value={month}
            onChange={newMonth => {
              const now = value.clone().month(newMonth);
              onChange(now);
            }}
          >
            {monthOptions}
          </Select>
        </Col>
      </Row>
    </div>
  );
};

const CalendarBox = (props: CalendarBoxType) => {
	const [music, setMusic] = useState<Music | null>(null);
	const [mode, setMode] = useState<CalendarMode>('year');
	const handleSelectSong = (id: number) => {
		setMusic(props.musics[id]);
		showModal();
	}

  const monthCellRender = (value: Moment) => {
    const listData = getMonthData(value, props.musics);
    return (
      <ul style={styles.events}>
        <li style={{ fontSize: '25px' }}>{listData.length}</li>
        {listData.map((item, id) => (
          <li key={id} onClick={() => handleSelectSong(item.musicId)}>
            <Badge status={item.type as BadgeProps['status']} text={item.content} />
          </li>
        ))}
      </ul>
    );
  };

  const dayCellRender = (value: Moment) => {
    const listData = getListData(value, props.musics);
    return (
      <ul style={styles.events}>
        {listData.map((item, id) => (
          <li key={id} onClick={() => handleSelectSong(item.musicId)}>
            <Badge status={item.type as BadgeProps['status']} text={item.content} />
          </li>
        ))}
      </ul>
    );
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return <div>
  	<Calendar
	  	dateCellRender={dayCellRender}
	  	monthCellRender={monthCellRender}
      mode={mode}
      onPanelChange={(date: moment.Moment, mode: string) => setMode(mode as CalendarMode)}
	  	defaultValue={moment(props.year, 'YYYY')}
      headerRender={({ value, type, onChange, onTypeChange }) => <CalendarHeader 
        value={value}
        type={type}
        onChange={onChange}
        onTypeChange={onTypeChange}
      />}
      
	  	// onChange={(e:any) => {
	  	// 	if (e.format('YYYY') !== props.year)
	  	// 		props.selectYear(e.format('YYYY'));
	  	// }}
	  />
	  {music && <ModalMusic
      music={music}
      isModalVisible={isModalVisible}
      handleOk={handleOk}
      handleCancel={handleCancel}
      selectMusic={props.selectMusic}
      deleteMusic={props.deleteMusic}
    />}
	</div>;
};

export default CalendarBox;
